module.exports = "pegasus_template/assets/lp/travel/bg1.png";